<template>
  <div>
    <b-row>
      <b-col cols="12" md="6">
        <Endereco v-model="endereco" ref="endereco" />
      </b-col>
      <b-col cols="12" md="6">
        <h3>Telefone e Mídias Sociais</h3>
        <hr class="mt-0 mb-3" />
        <Contatos v-model="contatos" ref="contatos" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Endereco from "@/components/Form/Endereco.vue";
import Contatos from "@/components/Form/Contatos.vue";
import { mapState } from "vuex";

export default {
  components: { Endereco, Contatos },
  props: {
    cliente_type: {
      type: String,
      default: "pj",
    },
  },
  data: () => ({
    validations: {
      endereco: true,
      contatos: true,
    },
  }),

  computed: {
    ...mapState("clientes", ["cliente"]),
    endereco: {
      set(value) {
        if (this.cliente_type == "pj") {
          this.cliente.pessoa_juridica.endereco = value;
        } else {
          this.cliente.pessoa_fisica.endereco = value;
        }
      },
      get() {
        return this.cliente_type == "pj"
          ? this.cliente.pessoa_juridica.endereco
          : this.cliente.pessoa_fisica.endereco;
      },
    },
    contatos: {
      set(value) {
        if (this.cliente_type == "pj") {
          this.cliente.pessoa_juridica.contatos = value;
        } else {
          this.cliente.pessoa_fisica.contatos = value;
        }
      },
      get() {
        return this.cliente_type == "pj"
          ? this.cliente.pessoa_juridica.contatos
          : this.cliente.pessoa_fisica.contatos;
      },
    },
  },
  methods: {
    isValid() {
      this.validations.endereco = this.$refs.endereco.isValid();
      this.validations.contatos = this.$refs.contatos.isValid();

      return Object.values(this.validations).every(Boolean);
    },
  },
  created() {},
};
</script>

<style lang="scss"></style>
